import { useId, useState } from "react";

interface FormError {
  id: string;
  message: string;
}

export function useFormErrors(): [FormError[], (messages: string[]) => void] {
  const [errors, setErrors] = useState<FormError[]>([]);

  const reactId = useId();

  const setFormErrors = (messages: string[]) =>
    setErrors(
      messages.map((msg, index) => ({
        id: `form-error-${reactId}-${index}`,
        message: msg,
      })),
    );

  return [errors, setFormErrors];
}
